import { Injectable } from '@angular/core';
import {UserService} from "../services/user.service";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class KycserviceService {
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router,private userService : UserService) {
    }

    /*
          api call for get KYC list
       */
    public getKycList(search):Observable<any> {
        
        return this.userService.request('get','customerskyc', null, {search:search});
    }

    /*
    * api call for kyc verify by id */
    public getKycVerifyById(id):Observable<any>{
        return this.userService.request('get','updatekyc',null,{id:id,status:"Approve"});
    }


    /* api call for Kyc Reject by id */
    public setKycReject(obj):Observable<any>{
        return this.userService.request('get','updatekyc',null,{id:obj.id,status:"Rejected",reason:obj.reason});
    }

    /*
    * api call for Kyc Remove by id */
    public setKycRemove(id):Observable<any>{
        return this.userService.request('get','removekyc',null,{id:id});
    }

    /*
    * api call for kyc pending by id */
    public kycPending(id):Observable<any>{
        return this.userService.request('get','updatekyc',null,{id:id,status:"Pending"});
    }
    // api call for add kyc plan
    public AddKYCPlan(data):Observable<any>{
        return this.userService.request('post','addkycplan',data);
    }

    //api call for get all kyc plan
    public getAllKYCPlan():Observable<any>{
        return this.userService.request('get','getadminkycplan',null);
    }

    // api call for get kyc plan by id

    public getKYCPlanById(id):Observable<any>{
        return this.userService.request('get','kycplanbyid',null,{id:id});
    }

    public getuserkyc(search):Observable<any> {
        console.log('searach user id',search);
        
        return this.userService.request('get','getUserkyc', null, {search:search});
    }

    public getkycbyadmin(search):Observable<any> {
        return this.userService.request('get','getkycbyadmin', null, {search:search});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/kycservice.service.ts